// 图片(正式时需要换成备注的域名)
export const imageUrl = "https://ossfastmake.xlkapp.com/";
// export const adminUrl = 'https://makeadmin.xshangyun.com/' //正式
export const adminUrl = "https://makeadmin.qingsite.cn"; //测试

/** 测试 **/
// export const SOCKET_AI_URL = "wss://jlsockettest.youzhiapp.com/";

/** 预上线 正式库 **/
// export const SOCKET_AI_URL = 'wss://jlsockettest-yu.youzhiapp.com/'

/** 正式 **/
// AI 走主域 Java 网关(/chatAi 由 nginx 转发到 8099)，与小程序端正式环境一致
export const SOCKET_AI_URL = 'wss://jielong.huolieyun.com/'  //正式 socket地址
// 旧 AI 网关(jielong-Agent)，保留可回切:
// export const SOCKET_AI_URL = 'wss://jlsocket.huolieyun.com/'  //正式 socket地址
//

// 报名管家企微客服链接（PC 端替代小程序 open-type="contact" 客服按钮）
export const customerServiceUrl = "https://work.weixin.qq.com/kfid/kfc0ee6a2a3fb74f172";

